export default __webpack_public_path__ + "static/Leech_Blood-df99d900d209e13ec1a3df5926f7fedb.png";